import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useIntl } from 'react-intl';
import MarketsLayout from '@fuww/library/src/Markets';
import Tabs from '../Tabs';
import Head from '../Head';
import getMarketBreadcrumbs from './getBreadcrumbs';
import throw404 from '../../lib/throw404';
import messages from '../../lib/messages.mjs';

const marketPropertyTypes = {
  data: PropTypes.shape({
    market: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      body: PropTypes.string,
    }),
  }).isRequired,
};

type MarketProperties = InferProps<typeof marketPropertyTypes>;

const Market = ({ data: { market } }: MarketProperties) => {
  const intl = useIntl();

  if (!market) {
    return throw404();
  }

  const {
    id: marketId, name, description, body,
  } = market;

  return (
    <>
      <Head
        title={intl.formatMessage(messages['market.title'], { name })}
        description={
          description ?? intl.formatMessage(messages['markets.description'])
        }
        subjectType="Market"
        subjectId={marketId}
      />
      <MarketsLayout
        title={name}
        description={description}
        breadcrumbs={getMarketBreadcrumbs({ marketId, marketName: name })}
        tabs={<Tabs />}
      >
        {
          body && (
            <div
            // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )
        }
      </MarketsLayout>
    </>
  );
};

Market.propTypes = marketPropertyTypes;

export default Market;
